import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { QuiSuisJe } from "@/components/sections/QuiSuisJe";
import { SocialProof } from "@/components/sections/SocialProof";
import { Problems } from "@/components/sections/Problems";
import { Comparison } from "@/components/sections/Comparison";
import { Solutions } from "@/components/sections/Solutions";
import { SEOExplainer } from "@/components/sections/SEOExplainer";
import { GoogleBusiness } from "@/components/sections/GoogleBusiness";
import { QRCodeSection } from "@/components/sections/QRCodeSection";
import { Responsive } from "@/components/sections/Responsive";
import { Process } from "@/components/sections/Process";
import { Pricing } from "@/components/sections/Pricing";
import { Portfolio } from "@/components/sections/Portfolio";
import { ZonesLocales } from "@/components/sections/ZonesLocales";
import { FAQ } from "@/components/sections/FAQ";
import { Contact } from "@/components/sections/Contact";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-paper text-ink">
      <Navbar />
      <main id="main">
        <Hero />
        <QuiSuisJe />
        <SocialProof />
        <Problems />
        <Comparison />
        <SEOExplainer />
        <Solutions />
        <GoogleBusiness />
        <QRCodeSection />
        <Responsive />
        <Process />
        <Pricing />
        <Portfolio />
        <ZonesLocales />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
